// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessShovel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m20.138 9.662-3.89 3.89a1.25 1.25 0 0 1-1.767 0l-1.228-1.229-9.032 9.031c-.178.179-.481.165-.676-.03l-.708-.707c-.195-.195-.208-.498-.03-.677l9.032-9.031-1.6-1.6a1.25 1.25 0 0 1 0-1.768l3.888-3.89a3.75 3.75 0 0 1 5.304 0l.707.708a3.75 3.75 0 0 1 0 5.303zm-5.843 1.582 1.07 1.07L19.077 8.6a2.25 2.25 0 0 0 0-3.182l-.707-.707a2.25 2.25 0 0 0-3.182 0l-3.712 3.713 1.523 1.523 1.7-1.29c.258-.196.587-.2.777-.01l.119.119c.19.19.185.518-.011.777z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessShovel;
